import React from 'react';
import { Button, Dropdown, Menu, Icon, message } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { SvgIconText } from 'freesia-ui';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";
import copy from 'copy-to-clipboard';

export default class ObjectsEditor extends PropertyEditor {

    state = {
        values: []
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e, index) {
        let values = this.state.values;
        values[index] = e.target.value;
        this.props.source.value = [...values];
        this.setState({ values: values });
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({ values: this.props.source.value });
    }

    componentWillMount() {
        super.componentWillMount();
        this.setState({ values: this.props.source.value });
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
        this.setState({ values: nextProps.source.value });
    }

    getItemBackgroundColor(v, item) {

        if (item.enabled === false)
            return "#a2a2a233";

        // if (this.props.source.colorful) {
        //     const color = getRandomColorOpacityDot2(v);
        //     return color;
        // }

        return null;
    }

    add() {

        if (this.props.source.clickAdd === false)
            return;

        let values = this.state.values;
        values.push(this.props.source.modelGetter ? this.props.source.modelGetter() : new this.props.source.modelTemplate());
        this.props.source.value = [...values];
        this.setState({
            values
        })
    }

    copyItem(index) {
        let item = this.state.values[index];
        item = item && item.toObject && item.toObject() || item;
        localStorage.__propertygrid_editor_objects__ = JSON.stringify(item);
        message.success("复制成功");
    }

    pasteItem(index) {

        let values = this.state.values;

        try {
            let m = values[index];
            let json = localStorage.__propertygrid_editor_objects__;
            values[index] = this.props.source.modelGetter ? this.props.source.modelGetter(JSON.parse(json)) : new this.props.source.modelTemplate(JSON.parse(json));
            this.props.source.modelRemover && this.props.source.modelRemover(m);
            this.props.source.value = [...values];
            this.setState({
                values
            })
            message.success("粘贴替换成功");
        }
        catch (err) {
            console.error(err);
            message.success("粘贴替换失败");
        }

        this.setState({});
    }

    deleteItem(index) {
        let values = this.state.values;
        let m = values[index];
        this.props.source.modelRemover && this.props.source.modelRemover(m, index);

        values.splice(index, 1);
        this.props.source.value = [...values];
        this.setState({
            values
        })
    }

    upItem(index) {
        let values = this.state.values;
        let item = values[index];
        values.splice(index, 1);
        values.splice(index - 1, 0, item);

        this.props.source.value = [...values];
        this.setState({
            values
        });
    }

    downItem(index) {
        let values = this.state.values;
        let item = values[index];
        values.splice(index, 1);
        values.splice(index + 1, 0, item);

        this.props.source.value = [...values];
        this.setState({
            values
        });
    }

    append(e) {
        if (this.props.source.clickEnter !== false)
            this.props.propertyGrid.append(this.props.source, e);
    }


    onDragEnter(e) {
        e.dataTransfer.dropEffect = 'copy';
        e.preventDefault();
    }

    onDragOver(e) {
        e.dataTransfer.dropEffect = 'copy';
        e.preventDefault();
    }

    onDrop(e) {
        e.preventDefault();
        let model = e.dataTransfer.getData(this.props.source.droppableDataType);
        if (!model)
            return;

        try {
            model = JSON.parse(model);
        }
        catch (err) {

        }

        let values = this.state.values;
        values.push(this.props.source.modelGetterOnDrop(model, this.props.source._sys.owner));
        this.props.source.value = [...values];
        this.setState({
            values
        })
    }

    onItemDragStart(e, c, index) {

        if (!this.props.source.itemDraggableDataType)
            return;

        let o = {
            index: index,
            item: c.toObject(),
        }

        e.dataTransfer.effectAllowed = 'copy';
        e.dataTransfer.setData(this.props.source.itemDraggableDataType, JSON.stringify(o));
    }

    onItemDragEnter(e, v, index) {
        e.dataTransfer.dropEffect = 'copy';
        e.preventDefault();
    }

    onItemDragOver(e, v, index) {
        e.dataTransfer.dropEffect = 'copy';
        e.preventDefault();
    }

    onItemDrop(e, v, index) {
        e.preventDefault();
        if (!this.props.source.itemDroppableDataType)
            return;

        let model = null;
        let dataType = null;

        if (typeof this.props.source.itemDroppableDataType === "string") {
            model = e.dataTransfer.getData(this.props.source.itemDroppableDataType);
            dataType = this.props.source.itemDroppableDataType;
        }

        else if (this.props.source.itemDroppableDataType instanceof Array) {
            for (let i = 0; i < this.props.source.itemDroppableDataType.length; i++) {
                const element = this.props.source.itemDroppableDataType[i];
                model = e.dataTransfer.getData(element);
                dataType = element;
                if (model)
                    break;
            }
        }

        if (!model)
            return;

        model = JSON.parse(model);
        this.props.source.itemOnDrop && this.props.source.itemOnDrop(v, index, model, dataType);
    }

    renderDraggable() {
        return (
            <Button className="objects-editor-droppable-btn" onClick={this.add.bind(this)}
                onDragEnter={e => this.onDragEnter(e)}
                onDragOver={e => this.onDragOver(e)}
                onDrop={e => this.onDrop(e)}>
                <div className="">{this.props.source.droppableText}</div>
            </Button>
        )
    }

    render() {
        let values = this.state.values;
        const droppable = this.props.source.droppable;

        return (
            <div>
                {values.map((v, index) => {

                    let title = v && v.toString();
                    let tip = title;
                    let btnHeight = 32;
                    if (title && title.svg && title.text && title.description) {
                        tip = title.text + " - " + title.description;
                        btnHeight = "auto";
                        title = (
                            <div className="layout-h fill w0 center" title={title.text}>
                                <SvgIconText type={title.svg} size="lg" />
                                <div className="layout-v sp-left-md fill w0">
                                    <div className="name-text primary-text text-nowrap">{title.text}</div>
                                    <div className="description-text text-nowrap">{title.description}</div>
                                </div>
                            </div>
                        );
                    }
                    else if (title && title.svg && title.text) {
                        tip = title.text;
                        title = (
                            <div className="layout-h fill w0 center" title={title.text}>
                                <SvgIconText type={title.svg} />
                                <div className="sp-left-md fill w0 text-nowrap">{title.text}</div>
                            </div>
                        );
                    }
                    else if (title && title.element && title.text) {
                        tip = title.text;
                        title = title.element;
                    }
                    else {
                        tip = title + "";
                        title = <div title={tip} className="fill w0 text-nowrap">{tip}</div>
                    }

                    const menu = (
                        <Menu>
                            {this.props.source.menuExtraBeforeGetter && this.props.source.menuExtraBeforeGetter(index, v)}
                            {this.props.source.menuExtraBeforeGetter && <Menu.Divider /> || null}

                            {this.props.source.showMenuUp !== false && <Menu.Item key="up" onClick={e => this.upItem(index)}><SvgIconText spacing='md' type='#anticon-Uparrowsmall' text='上移' /></Menu.Item> || null}
                            {this.props.source.showMenuDown !== false && <Menu.Item key="down" onClick={e => this.downItem(index)}><SvgIconText spacing='md' type='#anticon-Downarrowsmall' text='下移' /></Menu.Item> || null}
                            {(this.props.source.showMenuUp !== false || this.props.source.showMenuDown !== false) && <Menu.Divider /> || null}
                            {this.props.source.showMenuCopy !== false && <Menu.Item key="copy" onClick={e => this.copyItem(index)}><SvgIconText spacing='md' type='#anticon-JSON-copy' text='复制' /></Menu.Item> || null}
                            {this.props.source.showMenuPaste !== false && <Menu.Item key="paste" onClick={e => this.pasteItem(index)}><SvgIconText spacing='md' type='#anticon-GroupCopy' text='粘贴并替换（慎用）' /></Menu.Item> || null}
                            {(this.props.source.showMenuCopy !== false || this.props.source.showMenuPaste !== false) && <Menu.Divider /> || null}
                            {this.props.source.showMenuDelete !== false && <Menu.Item key="delete" onClick={e => this.deleteItem(index)}><SvgIconText spacing='md' type='#anticon-trash-gray1' text='移除' /></Menu.Item> || null}

                            {this.props.source.menuExtraAfterGetter && <Menu.Divider /> || null}
                            {this.props.source.menuExtraAfterGetter && this.props.source.menuExtraAfterGetter(index, v)}
                        </Menu>
                    );

                    return <div key={index} className="layout-h center property-editor--objects-item">
                        <Button className="hstretch fill layout-h" title={tip} onClick={e => this.append(v)} style={{ boxShadow: 'unset', width: 0, padding: "5px 7px 5px 7px", textAlign: "left", height: btnHeight, backgroundColor: this.getItemBackgroundColor(tip, v), opacity: v.enabled !== false ? 1 : .5 }}
                            draggable={this.props.source.itemDraggable}
                            onDragStart={e => this.onItemDragStart(e, v, index)}
                            onDragEnter={e => this.onItemDragEnter(e, v, index)}
                            onDragOver={e => this.onItemDragOver(e, v, index)}
                            onDrop={e => this.onItemDrop(e, v, index)}>
                            <div className={"layout-h fill w0 text-nowrap " + ((!v || !v.enabled) && v.enabled !== undefined ? "deleted-text-normal" : "")}>{title}</div>
                        </Button>

                        <Dropdown overlay={menu} trigger={['click']}>
                            <Button
                                className='sp-left btn-bd-focus-none btn-pd-sm btn-layer-node btn-bk-hover btn-bd-none'
                                style={{ padding: '7px 5px' }}>
                                <EllipsisOutlined type="ellipsis" />
                            </Button>
                        </Dropdown>
                        {/* <Button className="btn-bd-focus-none btn-pd-sm btn-bk-hover btn-bd-none image-selector sp-left" onClick={e => this.deleteItem(index)} >
                            <SvgIconText type="#anticon-trash-gray1" />
                        </Button> */}
                    </div>
                })
                }
                {
                    values.length >= (this.props.source.max || 999999999) ? null : (droppable ? this.renderDraggable() : <Button onClick={this.add.bind(this)} style={{ marginTop: 3 }}>添加</Button>)
                }
            </div >
        );
    }
}

PropertyGridUtils.register("objects", (source, propertyGrid) => <ObjectsEditor source={source} propertyGrid={propertyGrid} />);
